import { FC } from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./Home";
import Datenschutz from "./Datenschutz";
import Impressum from "./Impressum";

const App: FC = () => {
  return (
    <Routes>
      <Route path={"/"} element={<Home />} />
      <Route path={"/datenschutz"} element={<Datenschutz />} />
      <Route path={"/impressum"} element={<Impressum />} />
    </Routes>
  );
};

export default App;
